import { Dispatch, Middleware, MiddlewareAPI, Action } from 'redux'
import { MESSAGE_TYPES } from 'types/globalMessaging'
import { showMessage } from 'utils/actions/globalMessaging'
import {
  CREATE_SPOT_BIDDING_RULE_ACTION_TYPES,
  UPDATE_SPOT_BIDDING_RULE_ACTION_TYPES,
  DELETE_SPOT_BIDDING_RULE_ACTION_TYPES,
  getSpotBiddingConfig,
  UPDATE_SPOT_BIDDING_CONFIG_ACTION_TYPES,
} from 'apps/spot-quote-control-panel/utils/actions/spotBiddingConfig'
import { IStore } from '../reducers/types'

const SUCCESS_ACTION_TYPES = {
  [CREATE_SPOT_BIDDING_RULE_ACTION_TYPES.CREATE_SPOT_BIDDING_RULE_SUCCESS]: 'added',
  [UPDATE_SPOT_BIDDING_RULE_ACTION_TYPES.UPDATE_SPOT_BIDDING_RULE_SUCCESS]: 'updated',
  [DELETE_SPOT_BIDDING_RULE_ACTION_TYPES.DELETE_SPOT_BIDDING_RULE_SUCCESS]: 'deleted',
}

export const shipperRates: Middleware = (store: MiddlewareAPI<Dispatch, IStore>) => (
  next: Dispatch
) => (action: Action<string>) => {
  if (Object.keys(SUCCESS_ACTION_TYPES).includes(action.type)) {
    const {
      spotBiddingConfig: { spotBiddingConfig: { configType, id } = {} } = {},
    } = store.getState()
    if (configType) {
      store.dispatch(getSpotBiddingConfig(id))
    }

    const message = SUCCESS_ACTION_TYPES[action.type]
    store.dispatch(
      showMessage(`Spot bidding rule successfully ${message}.`, {
        type: MESSAGE_TYPES.info,
        closeDelay: 5000,
      })
    )
  }

  if (action.type === UPDATE_SPOT_BIDDING_CONFIG_ACTION_TYPES.UPDATE_SPOT_BIDDING_CONFIG_SUCCESS) {
    store.dispatch(
      showMessage('Shipper details successfully updated.', {
        type: MESSAGE_TYPES.info,
        closeDelay: 5000,
      })
    )
  }

  return next(action)
}
